<script>
    import {url} from "@sveltech/routify";
    import {apiFetch} from '../../../apiFetch';
    import {_} from 'svelte-i18n';
    import ListGroup from 'sveltestrap/src/ListGroup.svelte';
    import ListGroupItem from 'sveltestrap/src/ListGroupItem.svelte';
    import NewEventButton from "../../../components/event/NewEventButton.svelte";
    import Spinner from "../../../components/spinner/Spinner.svelte";
    import DatePeriod from "../../../components/date/DatePeriod.svelte";
    import EventImage from "../../../components/event/EventImage.svelte";
</script>

<div class="list-group-container">
    <h5>{$_('page.campaign.index.campaignsTitle')}</h5>
    {#await apiFetch('/campaigns')}
        <Spinner/>
    {:then data}
        <ListGroup flush>
            {#each data.campaigns as { id, name }}
                <ListGroupItem href={$url('../:campaignId', { campaignId: id })} action>
                    <h6>{name}</h6>
                </ListGroupItem>
            {/each}
        </ListGroup>
    {:catch error}
        {@debug error}
        <p>An error occurred!</p>
    {/await}
    <p>
        <small>{$_('page.campaign.index.howToCreateCampaign')}</small>
    </p>
</div>


<div class="list-group-container events-list">
    <div style="position: absolute; right: 0px;">
        <NewEventButton/>
    </div>
    <h5>{$_('page.campaign.index.eventsTitle')}</h5>
    {#await apiFetch('/organizations/events')}
        <Spinner/>
    {:then data}
        <ListGroup flush>
            {#each data.events as { id, name, game, event_from, event_to, image_url }}
                <ListGroupItem href={$url('../../events/:eventId', { eventId: id })} action>
                    <div class="date-container text-dark d-block">
                        <DatePeriod periodFrom={event_from} periodTo={event_to}/>
                    </div>
                    <EventImage event={{image_url: image_url}} />
                    <h6>{name}</h6>
                </ListGroupItem>
            {/each}
        </ListGroup>
    {:catch error}
        {@debug error}
        <p>An error occurred!</p>
    {/await}
</div>

<style>
    .date-container {
        position: absolute;
        background-color: #d9dbde;
        opacity: 0.7;
        padding-left: 20px;
        width: 90%;
        font-size: 12px;
    }
    .events-list h6 {
        position: absolute;
        left: 50px;
        bottom: 20px;
        font-size: 16px;
    }
    .events-list .list-group-item-action {
        padding: 0px;
    }
</style>